import React, { HTMLAttributes } from 'react';
import VoxelText from '../Text/VoxelText';

export interface VoxelTableEmptyProps
  extends Pick<HTMLAttributes<HTMLTableRowElement>,
    'onClick'
  > {
  colSpan: number;
  className?: string;
}

export const VoxelTableRowEmpty: React.FC<VoxelTableEmptyProps> = ({ children, colSpan, onClick, className, ...divProps }) => {

  return (
    <tr className={`${className}`}>
      <td colSpan={colSpan} align='left' className='px-4 py-2.5'>
        <VoxelText variant="bread-normal" className='italic'>{children}</VoxelText>
      </td>
    </tr>
  );
};

export default VoxelTableRowEmpty;
